/* Retour Stripe — annulation. */
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-[#0b0d12] text-zinc-100 flex items-center justify-center p-6" data-testid="payment-cancel-page">
      <div className="max-w-md w-full text-center space-y-4">
        <XCircle className="w-12 h-12 text-zinc-500 mx-auto" />
        <h1 className="text-xl font-semibold">Paiement annulé</h1>
        <p className="text-sm text-zinc-400">Aucun montant n'a été prélevé. Vous pouvez reprendre quand vous voulez.</p>
        <Link to="/app/facturation" className="btn-primary inline-flex text-sm mt-2">Retour aux plans</Link>
      </div>
    </div>
  );
}
